/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Ach/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BankTransferIcon from 'DesignSystem/Svgs/BankTransferIcon/index'
import HolderName from './HolderName/index'
import Last4 from './Last4/index'
import LocationName from './LocationName/index'
import PlatformFee from './PlatformFee/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Ach({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Details/Ach",
  amount
  
}) {
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<BankTransferIcon
  viewPath={`${viewPath}/BankTransferIcon`}
 stroke={dtColorsNeutral700}
 width={30}
/>
<div
  data-testid="Ach.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-hD2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Last4
  viewPath={`${viewPath}/Last4`}
/>
<div
  data-testid="Ach.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<HolderName
  viewPath={`${viewPath}/HolderName`}
/>
<LocationName
  viewPath={`${viewPath}/LocationName`}
/>
</div>
<PlatformFee
  viewPath={`${viewPath}/PlatformFee`}
 amount={amount}
/>
</div>
{children}
</React.Fragment>)
}